import { render, staticRenderFns } from "./MultiContentComponent.vue?vue&type=template&id=641da392&scoped=true"
import script from "./MultiContentComponent.vue?vue&type=script&lang=js"
export * from "./MultiContentComponent.vue?vue&type=script&lang=js"
import style0 from "./MultiContentComponent.vue?vue&type=style&index=0&id=641da392&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641da392",
  null
  
)

export default component.exports